module.exports = __webpack_public_path__ + "images/bannerFR-e3eba717d8f77dc34dfe31fed2761644.jpg";